
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingItemsGrid extends Serenity.EntityGrid<SKURepricingItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.SKURepricingItems'; }
        protected getDialogType() { return SKURepricingItemsDialog; }
        protected getIdProperty() { return SKURepricingItemsRow.idProperty; }
        protected getInsertPermission() { return SKURepricingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SKURepricingItemsRow.localTextPrefix; }
        protected getService() { return SKURepricingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}